import React from 'react';
import classnames from 'classnames';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './createSearchButton.module.scss';
import alertIconRed from '../../icons/alert-icon-red.svg';

interface DisabledSCreateSearchBtnProps {
  message: string;
}

export const DisabledCreateSearchButton = ({
  message,
}: DisabledSCreateSearchBtnProps) => {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Popover
          id="create-search-disabled"
          className={styles.searchDisabledPopover}
        >
          <Popover.Content className={styles.searchDisabledPopoverBody}>
            {message}
          </Popover.Content>
        </Popover>
      }
    >
      <span
        className={classnames(
          'position-relative disabledRequestBtn',
          styles.disabledCreateSearchBtn
        )}
      >
        <Button
          variant="primary"
          data-cy={'create-request:create-request-disabled-button'}
          disabled
          data-testid="CreateRequestButton"
        >
          {'Create Request'}
        </Button>
        <span className={styles.waringIcon}>
          <img src={alertIconRed} alt="warningIcon"></img>
        </span>
      </span>
    </OverlayTrigger>
  );
};
